import { LocationHoursModel, HoursModel } from '@leverege/recovr-models';
import LocationHoursDetailModel from './LocationHoursDetailModel';
import LocationHoursDetailRenderer from './LocationHoursDetailRenderer';
export default {
  install(molten) {
    const objectType = 'location';
    molten.addPlugin('Model', {
      type: 'recovr.detail.locationHours',
      model: LocationHoursDetailModel
    });
    molten.addPlugin('Model', {
      type: 'recovr.locationHours',
      model: LocationHoursModel
    });
    molten.addPlugin('Model', {
      type: 'recovr.locationHours.hours',
      model: HoursModel
    });
    molten.addPlugin('Detail', {
      name: 'Location Hours',
      objectType,
      create: () => {
        const json = LocationHoursDetailModel.create(objectType);
        return json;
      },
      layout: {
        group: []
      }
    });
    molten.addPlugin('DetailRenderer', {
      type: LocationHoursDetailModel.TYPE,
      renderer: LocationHoursDetailRenderer
    });
  }
};